import { AbstractControl, FormControl, ValidatorFn, Validators } from '@angular/forms';
import { CartAmountValidator, OrderTypes } from '@next/core-lib/cart';
import { LocaleService } from '@next/core-lib/i18n';
import { AllowedOrderRoles } from '@next/core-lib/models';

import { ValidatableSku } from 'src/app/shared/validatable-sku.model';

export function isItemTypeEligibleForCartType(catalogItem: ValidatableSku, cartType?: OrderTypes) {
  return !cartType || catalogItem.orderingInformation.allowedOrderTypes?.includes(cartType);
}

export function skuIsOrderable(sku: ValidatableSku, hasAtLeastAdvisorRole: boolean): boolean {
  return sku.orderingInformation && isUserAllowedToOrderItem(sku, hasAtLeastAdvisorRole);
}

export function decorateFormControl(row: ValidatableSku, formControl: FormControl, localeService: LocaleService): void {
  const validators = Array<ValidatorFn>();
  validators.push(Validators.min(row?.orderingInformation?.minimumOrderUnitQuantity ?? 1));
  validators.push(Validators.required);

  if (row?.orderingInformation?.maximumOrderUnitQuantity) {
    validators.push(Validators.max(row.orderingInformation.maximumOrderUnitQuantity));
  }

  if (row?.orderingInformation?.minimumOrderUnitQuantity && row?.orderingInformation?.increaseOrderUnitQuantity) {
    const validator = new CartAmountValidator(
      row?.orderingInformation?.minimumOrderUnitQuantity,
      row?.orderingInformation?.maximumOrderUnitQuantity,
      row?.orderingInformation?.increaseOrderUnitQuantity,
      localeService,
    );
    validators.push((control: AbstractControl) => validator.validate(control));
  }

  formControl.setValidators(validators);
}

export function isUserAllowedToOrderItem(catalogItem: ValidatableSku, hasAtLeastAdvisorRole: boolean) {
  const allowedUsers = catalogItem?.orderingInformation?.allowedUsers ?? AllowedOrderRoles.none;

  switch (allowedUsers) {
    case AllowedOrderRoles.all:
      return true;

    case AllowedOrderRoles.advisorsAndAbove:
      return hasAtLeastAdvisorRole;

    case AllowedOrderRoles.none:
    default:
      return false;
  }
}
